import { t, getLocale } from '../locales/i18n.js';
import { openArticleModal } from '../components/ArticleModal.js';
import { allMediaArticles } from '../data/mediaMentions.js';
import { getArticlesByCategory, getAllArticles, subscribeArticleStore } from '../services/articleStore.js';
import { articleIndexTranslations } from '../locales/articleTranslationsData.js';
import { getSvgIcon } from '../components/Icons.js';

const newsHubTexts = {
  cs: {
    eyebrow: 'CENTRUM INFORMACÍ A NOVINEK',
    title: 'Novinky',
    desc: 'Prozkoumejte aktuální dění, podrobné případové studie z ostrého provozu a produktové aktualizace technologie Sound Event Detector.',
    cards: [
      {
        route: 'latest-news',
        iconKey: 'newsLatest',
        color: 'var(--blue-primary)',
        accent: 'var(--blue-primary)',
        title: 'Aktuality a tisk',
        desc: 'Oficiální oznámení, tiskové zprávy a mediální výstupy ze světa akustické bezpečnosti a umělé inteligence.',
        btn: 'Zobrazit aktuality →'
      },
      {
        route: 'case-studies',
        iconKey: 'newsStudies',
        color: '#10b981',
        accent: '#10b981',
        title: 'Případové studie',
        desc: 'Reálné reference a ověřené výsledky nasazení SED v chytrých městech, nemocnicích, školách a průmyslu.',
        btn: 'Zobrazit případové studie →'
      },
      {
        route: 'product-updates',
        iconKey: 'newsUpdates',
        color: '#f59e0b',
        accent: '#f59e0b',
        title: 'Aktualizace produktů',
        desc: 'Přehled nových verzí akustických detekčních algoritmů, aktualizací firmwaru a technických vylepšení.',
        btn: 'Zobrazit aktualizace →'
      }
    ]
  },
  en: {
    eyebrow: 'NEWS & MEDIA HUB',
    title: 'News & Updates',
    desc: 'Explore the latest press releases, field-tested case studies from live deployments, and product updates from Sound Event Detector.',
    cards: [
      {
        route: 'latest-news',
        iconKey: 'newsLatest',
        color: 'var(--blue-primary)',
        accent: 'var(--blue-primary)',
        title: 'Latest News & Press',
        desc: 'Official company announcements, press releases, and media coverage from the world of acoustic security AI.',
        btn: 'Explore Latest News →'
      },
      {
        route: 'case-studies',
        iconKey: 'newsStudies',
        color: '#10b981',
        accent: '#10b981',
        title: 'Case Studies',
        desc: 'Real field deployments, validation metrics, and success stories across Smart Cities, hospitals, and critical infrastructure.',
        btn: 'Explore Case Studies →'
      },
      {
        route: 'product-updates',
        iconKey: 'newsUpdates',
        color: '#f59e0b',
        accent: '#f59e0b',
        title: 'Product Updates',
        desc: 'Technical changelogs, new acoustic AI detector releases, firmware optimizations, and VMS integration updates.',
        btn: 'Explore Product Updates →'
      }
    ]
  },
  de: {
    eyebrow: 'NACHRICHTEN & MEDIEN-HUB',
    title: 'Nachrichten',
    desc: 'Entdecken Sie aktuelle Pressemitteilungen, Fallstudien aus dem Praxiseinsatz und Produkt-Updates des Sound Event Detectors.',
    cards: [
      {
        route: 'latest-news',
        iconKey: 'newsLatest',
        color: 'var(--blue-primary)',
        accent: 'var(--blue-primary)',
        title: 'Aktuelle Nachrichten & Presse',
        desc: 'Offizielle Mitteilungen, Pressemeldungen und Medienberichte zur akustischen KI-Sicherheit.',
        btn: 'Nachrichten ansehen →'
      },
      {
        route: 'case-studies',
        iconKey: 'newsStudies',
        color: '#10b981',
        accent: '#10b981',
        title: 'Fallstudien',
        desc: 'Echte Praxiserfahrungen und Resultate in Smart Cities, Kliniken und Industrieanlagen.',
        btn: 'Fallstudien ansehen →'
      },
      {
        route: 'product-updates',
        iconKey: 'newsUpdates',
        color: '#f59e0b',
        accent: '#f59e0b',
        title: 'Produkt-Updates',
        desc: 'Neue KI-Klassifikatoren, Firmware-Updates und VMS-Erweiterungen.',
        btn: 'Updates ansehen →'
      }
    ]
  },
  es: {
    eyebrow: 'CENTRO DE NOTICIAS Y MEDIOS',
    title: 'Noticias',
    desc: 'Explore comunicados de prensa, estudios de caso de implementaciones reales y actualizaciones técnicas de Sound Event Detector.',
    cards: [
      {
        route: 'latest-news',
        iconKey: 'newsLatest',
        color: 'var(--blue-primary)',
        accent: 'var(--blue-primary)',
        title: 'Últimas Noticias y Prensa',
        desc: 'Comunicados oficiales y cobertura en medios del sector de seguridad acústica con IA.',
        btn: 'Ver noticias →'
      },
      {
        route: 'case-studies',
        iconKey: 'newsStudies',
        color: '#10b981',
        accent: '#10b981',
        title: 'Estudios de Caso',
        desc: 'Casos reales y métricas de éxito en ciudades inteligentes, hospitales e industria.',
        btn: 'Ver estudios de caso →'
      },
      {
        route: 'product-updates',
        iconKey: 'newsUpdates',
        color: '#f59e0b',
        accent: '#f59e0b',
        title: 'Actualizaciones de Producto',
        desc: 'Nuevos clasificadores de IA, actualizaciones de firmware y compatibilidad VMS.',
        btn: 'Ver actualizaciones →'
      }
    ]
  },
  pt: {
    eyebrow: 'CENTRAL DE NOTÍCIAS E IMPRENSA',
    title: 'Notícias',
    desc: 'Explore comunicados de imprensa, estudos de caso de operações reais e atualizações de produtos Sound Event Detector.',
    cards: [
      {
        route: 'latest-news',
        iconKey: 'newsLatest',
        color: 'var(--blue-primary)',
        accent: 'var(--blue-primary)',
        title: 'Últimas Notícias e Imprensa',
        desc: 'Comunicados oficiais e reportagens sobre inteligência artificial acústica.',
        btn: 'Ver notícias →'
      },
      {
        route: 'case-studies',
        iconKey: 'newsStudies',
        color: '#10b981',
        accent: '#10b981',
        title: 'Estudos de Caso',
        desc: 'Casos reais de aplicação em cidades inteligentes, hospitais e indústrias.',
        btn: 'Ver estudos de caso →'
      },
      {
        route: 'product-updates',
        iconKey: 'newsUpdates',
        color: '#f59e0b',
        accent: '#f59e0b',
        title: 'Atualizações de Produto',
        desc: 'Novos algoritmos de deteção acústica, firmware e integrações VMS.',
        btn: 'Ver atualizações →'
      }
    ]
  },
  ar: {
    eyebrow: 'مركز الأخبار والإعلام',
    title: 'الأخبار والتحديثات',
    desc: 'استكشف البيانات الصحفية ودراسات الحالة من التطبيقات الحية وتحديثات المنتجات لكاشف الأصوات SED.',
    cards: [
      {
        route: 'latest-news',
        iconKey: 'newsLatest',
        color: 'var(--blue-primary)',
        accent: 'var(--blue-primary)',
        title: 'آخر الأخبار والبيانات الصحفية',
        desc: 'الإعلانات الرسمية والتغطية الإعلامية في مجال الأمان الصوتي بالذكاء الاصطناعي.',
        btn: 'استكشاف الأخبار ←'
      },
      {
        route: 'case-studies',
        iconKey: 'newsStudies',
        color: '#10b981',
        accent: '#10b981',
        title: 'دراسات الحالة',
        desc: 'تطبيقات ميدانية حقيقية وقصص نجاح عبر المدن الذكية والمستشفيات والبنية التحتية.',
        btn: 'استكشاف دراسات الحالة ←'
      },
      {
        route: 'product-updates',
        iconKey: 'newsUpdates',
        color: '#f59e0b',
        accent: '#f59e0b',
        title: 'تحديثات المنتجات',
        desc: 'سجلات التغييرات التقنية وإصدارات المصنفات الصوتية الجديدة وتحديثات البرامج الثابتة.',
        btn: 'استكشاف التحديثات ←'
      }
    ]
  }
};

const latestNewsUi = {
  en: {
    breadcrumbHome: 'Home',
    breadcrumbNews: 'News',
    breadcrumbCurrent: 'Latest News & Press',
    heroEyebrow: 'LATEST NEWS & PRESS',
    heroTitle: 'Aktuality a tisk',
    heroDesc: 'Official company press releases, public announcements, and articles regarding JALUD Embedded.',
    internalEyebrow: 'OFFICIAL ANNOUNCEMENTS',
    internalTitle: 'Aktuality',
    externalEyebrow: 'EXTERNAL MEDIA COVERAGE',
    externalTitle: 'Napsali o nás',
    externalDesc: 'External news reports, interviews, and TV broadcasts featuring Sound Event Detector.',
    readReport: 'Číst článek ↗',
    showMore: 'Zobrazit další mediální výstupy ↓',
    showLess: 'Zobrazit méně ↑',
    readBtn: 'Číst článek'
  },
  cs: {
    breadcrumbHome: 'Domů',
    breadcrumbNews: 'Novinky',
    breadcrumbCurrent: 'Aktuality a tisk',
    heroEyebrow: 'TISKOVÉ ZPRÁVY A MÉDIA',
    heroTitle: 'Aktuality a tisk',
    heroDesc: 'Oficiální tiskové zprávy, oznámení společnosti JALUD Embedded a články v médiích o Sound Event Detectoru.',
    internalEyebrow: 'OFICIÁLNÍ OZNÁMENÍ',
    internalTitle: 'Aktuality',
    externalEyebrow: 'MEDIÁLNÍ POKRYTÍ A REPORTÁŽE',
    externalTitle: 'Napsali o nás',
    externalDesc: 'Články, rozhovory a televizní reportáže o technologii SED publikované v nezávislých médiích.',
    readReport: 'Číst článek ↗',
    showMore: 'Zobrazit další zprávy z médií ↓',
    showLess: 'Zobrazit méně ↑',
    readBtn: 'Číst článek'
  },
  de: {
    breadcrumbHome: 'Startseite',
    breadcrumbNews: 'Nachrichten',
    breadcrumbCurrent: 'Aktuelles & Presse',
    heroEyebrow: 'PRESSE & AKTUELLES',
    heroTitle: 'Aktuelles und Presse',
    heroDesc: 'Offizielle Pressemitteilungen, Ankündigungen und Medienbeiträge über JALUD Embedded.',
    internalEyebrow: 'OFFIZIELLE MITTEILUNGEN',
    internalTitle: 'Aktuelles',
    externalEyebrow: 'MEDIENBERICHTE',
    externalTitle: 'In den Medien',
    externalDesc: 'Externe Presseberichte und Fernsehbeiträge über den Sound Event Detector.',
    readReport: 'Artikel lesen ↗',
    showMore: 'Weitere Berichte anzeigen ↓',
    showLess: 'Weniger anzeigen ↑',
    readBtn: 'Artikel lesen'
  },
  es: {
    breadcrumbHome: 'Inicio',
    breadcrumbNews: 'Noticias',
    breadcrumbCurrent: 'Noticias y Prensa',
    heroEyebrow: 'NOTICIAS Y PRENSA',
    heroTitle: 'Noticias y Prensa',
    heroDesc: 'Comunicados de prensa oficiales y cobertura mediática de JALUD Embedded.',
    internalEyebrow: 'COMUNICADOS OFICIALES',
    internalTitle: 'Noticias',
    externalEyebrow: 'EN LOS MEDIOS',
    externalTitle: 'Menciones en Prensa',
    externalDesc: 'Reportajes y entrevistas externas sobre Sound Event Detector.',
    readReport: 'Leer artículo ↗',
    showMore: 'Mostrar más noticias ↓',
    showLess: 'Mostrar menos ↑',
    readBtn: 'Leer artículo'
  },
  pt: {
    breadcrumbHome: 'Início',
    breadcrumbNews: 'Notícias',
    breadcrumbCurrent: 'Notícias e Imprensa',
    heroEyebrow: 'NOTÍCIAS E IMPRENSA',
    heroTitle: 'Notícias e Imprensa',
    heroDesc: 'Comunicados oficiais e reportagens sobre a JALUD Embedded.',
    internalEyebrow: 'COMUNICADOS OFICIAIS',
    internalTitle: 'Notícias',
    externalEyebrow: 'NA IMPRENSA',
    externalTitle: 'Mídia e Imprensa',
    externalDesc: 'Artigos e reportagens externas sobre o Sound Event Detector.',
    readReport: 'Ler artigo ↗',
    showMore: 'Ver mais matérias ↓',
    showLess: 'Ver menos ↑',
    readBtn: 'Ler artigo'
  },
  ar: {
    breadcrumbHome: 'الرئيسية',
    breadcrumbNews: 'الأخبار',
    breadcrumbCurrent: 'الأخبار والصحافة',
    heroEyebrow: 'الأخبار والصحافة',
    heroTitle: 'الأخبار والبيانات الصحفية',
    heroDesc: 'البيانات الصحفية الرسمية والتغطية الإعلامية لشركة JALUD Embedded.',
    internalEyebrow: 'الإعلانات الرسمية',
    internalTitle: 'الأخبار',
    externalEyebrow: 'التغطية الإعلامية',
    externalTitle: 'في وسائل الإعلام',
    externalDesc: 'تقارير إعلامية ومقابلات حول كاشف الأصوات SED.',
    readReport: 'قراءة المقال ↗',
    showMore: 'عرض المزيد من التقارير ↓',
    showLess: 'عرض أقل ↑',
    readBtn: 'قراءة المقال'
  }
};

/**
 * Renders the dedicated 3-card News Hub page (#news) matching Detekce card style
 */
export function renderNewsHubPage(onNavigate) {
  const container = document.createElement('div');
  container.className = 'sed-page';
  const lang = getLocale() || 'en';
  const hub = newsHubTexts[lang] || newsHubTexts.en;

  container.innerHTML = `
    <section class="sed-section" style="background: linear-gradient(165deg, var(--blue-light) 0%, #ffffff 70%); padding: 4.5rem 0 3rem;">
      <div class="sed-container">
        <div class="sed-section-header" style="max-width: 840px;">
          <div class="sed-eyebrow">${hub.eyebrow}</div>
          <h1 class="sed-page-hero-title">${hub.title}</h1>
          <p class="sed-section-desc">${hub.desc}</p>
        </div>
      </div>
    </section>

    <!-- 3 Hub Cards in Detekce Card Style -->
    <section class="sed-section" style="background-color: #ffffff; padding-bottom: 5rem;">
      <div class="sed-container">
        <div class="sed-grid-3" style="gap: 1.75rem;">
          ${hub.cards.map(card => `
            <div class="sed-card" style="display: flex; flex-direction: column; justify-content: space-between; min-height: 320px; background: #ffffff; border: 1.5px solid var(--slate-line); border-top: 4px solid ${card.accent}; border-radius: 14px; padding: 2rem; box-shadow: 0 4px 15px rgba(0,0,0,0.03); transition: transform 0.2s, box-shadow 0.2s;" onmouseover="this.style.transform='translateY(-4px)'; this.style.boxShadow='0 12px 28px rgba(0,0,0,0.08)';" onmouseout="this.style.transform='none'; this.style.boxShadow='0 4px 15px rgba(0,0,0,0.03)';">
              <div>
                <div style="width: 48px; height: 48px; border-radius: 12px; background: var(--blue-ultra-light); border: 1px solid var(--blue-light); display: flex; align-items: center; justify-content: center; margin-bottom: 1.25rem;">
                  ${getSvgIcon(card.iconKey, 24, card.color)}
                </div>
                <h3 class="sed-card-title" style="font-size: 1.25rem; font-weight: 800; color: var(--navy-dark); margin-bottom: 0.75rem; line-height: 1.35;">${card.title}</h3>
                <p class="sed-card-text" style="font-size: 0.92rem; line-height: 1.6; color: var(--text-dark); margin: 0; display: -webkit-box; -webkit-line-clamp: 4; -webkit-box-orient: vertical; overflow: hidden;">
                  ${card.desc}
                </p>
              </div>
              <div style="margin-top: 1.75rem;">
                <a href="#${card.route}" class="sed-btn sed-btn-primary" style="width: 100%; text-align: center; font-size: 0.88rem; font-weight: 700;" data-route="${card.route}">
                  ${card.btn}
                </a>
              </div>
            </div>
          `).join('')}
        </div>
      </div>
    </section>
  `;

  container.querySelectorAll('[data-route]').forEach(link => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      if (onNavigate) onNavigate(link.getAttribute('data-route'));
    });
  });

  return container;
}

/**
 * Renders the split Latest News page (#latest-news) with:
 * 1. Aktuality (Internal News)
 * 2. Napsali o nás (External Media with initial 6 items + Show More pagination)
 */
export function renderLatestNewsPage(onNavigate) {
  const container = document.createElement('div');
  container.className = 'sed-page';
  const lang = getLocale() || 'en';
  const ui = latestNewsUi[lang] || latestNewsUi.en;

  let internalArticles = getArticlesByCategory('latest-news');
  if (internalArticles.length === 0) internalArticles = getAllArticles();

  container.innerHTML = `
    <!-- Header Hero -->
    <section class="sed-section" style="background: linear-gradient(165deg, var(--navy-dark) 0%, var(--blue-dark) 100%); color: #ffffff; padding: 4.5rem 0 3.5rem;">
      <div class="sed-container">
        <div style="display: flex; gap: 0.5rem; align-items: center; font-size: 0.85rem; color: #cbd5e1; margin-bottom: 1.5rem; flex-wrap: wrap;">
          <a href="#home" style="color: #ffffff; text-decoration: none;" data-route="home">${ui.breadcrumbHome}</a> /
          <a href="#news" style="color: #ffffff; text-decoration: none;" data-route="news">${ui.breadcrumbNews}</a> /
          <span style="color: var(--blue-primary); font-weight: 700;">${ui.breadcrumbCurrent}</span>
        </div>
        <div class="sed-section-header" style="max-width: 840px; text-align: left; margin: 0;">
          <div class="sed-eyebrow" style="background: rgba(255,255,255,0.1); color: var(--blue-primary); border-color: rgba(255,255,255,0.2);">${ui.heroEyebrow}</div>
          <h1 class="sed-page-hero-title" style="color: #ffffff;">${ui.heroTitle}</h1>
          <p style="font-size: 1.15rem; color: #e2e8f0; line-height: 1.65; margin-bottom: 0;">${ui.heroDesc}</p>
        </div>
      </div>
    </section>

    <!-- Section 1: Aktuality (Internal Articles) -->
    <section class="sed-section" id="aktuality" style="background-color: #ffffff; padding: 4rem 0 3.5rem;">
      <div class="sed-container">
        <div class="sed-section-header" style="text-align: left; margin-bottom: 2.5rem;">
          <div class="sed-eyebrow">${ui.internalEyebrow}</div>
          <h2 class="sed-section-title" style="font-size: 2.2rem;">${ui.internalTitle}</h2>
        </div>

        <div id="sed-internal-news-grid" class="sed-grid-3">
          ${internalArticles.map(art => {
            const imgUrl = art.img || 'https://soundeventdetector.eu/wp-content/uploads/2024/02/2.png';
            const slug = art.slug || 'news-article';
            const trans = (articleIndexTranslations[lang] && articleIndexTranslations[lang][slug]) || {};
            const cleanTitle = trans.title || art.title || slug.replace(/-/g, ' ').toUpperCase();
            const rawText = trans.excerpt || art.excerpt || (art.content ? art.content.replace(/<[^>]+>/g, '').slice(0, 160) + '...' : 'Přečtěte si celý článek pro podrobnosti, fotografie a video reportáž.');
            const badgeCategory = trans.category || (lang === 'cs' ? 'Aktuality' : 'Latest News');

            return `
              <div class="sed-card" style="padding: 0; overflow: hidden; cursor: pointer; display: flex; flex-direction: column; justify-content: space-between; background: #ffffff; border: 1.5px solid var(--slate-line); border-radius: 14px; box-shadow: 0 4px 15px rgba(0,0,0,0.03); transition: transform 0.2s, box-shadow 0.2s;" onmouseover="this.style.transform='translateY(-3px)'; this.style.boxShadow='0 10px 25px rgba(0,0,0,0.08)';" onmouseout="this.style.transform='none'; this.style.boxShadow='0 4px 15px rgba(0,0,0,0.03)';" data-article-id="${slug}">
                <div>
                  <div style="height: 190px; overflow: hidden; background-color: var(--navy-dark); position: relative;">
                    <img src="${imgUrl}" alt="${cleanTitle}" style="width: 100%; height: 100%; object-fit: cover;">
                    <div style="position: absolute; top: 12px; left: 12px; background: rgba(53, 168, 223, 0.95); color: #ffffff; padding: 0.25rem 0.65rem; border-radius: var(--radius-badge); font-size: 0.72rem; font-weight: 800; text-transform: uppercase;">
                      ${badgeCategory}
                    </div>
                    ${art.date ? `
                      <div style="position: absolute; bottom: 12px; right: 12px; background: rgba(10, 25, 47, 0.85); color: #ffffff; padding: 0.2rem 0.6rem; border-radius: 4px; font-size: 0.72rem; font-weight: 700; backdrop-filter: blur(4px);">
                        ${art.date}
                      </div>
                    ` : ''}
                  </div>
                  <div style="padding: 1.5rem 1.5rem 1rem;">
                    <h3 class="sed-card-title" style="font-size: 1.15rem; font-weight: 800; color: var(--navy-dark); margin-bottom: 0.6rem; line-height: 1.35;">${cleanTitle}</h3>
                    <p class="sed-card-text" style="font-size: 0.9rem; line-height: 1.6; color: var(--text-dark); margin: 0; display: -webkit-box; -webkit-line-clamp: 3; -webkit-box-orient: vertical; overflow: hidden;">${rawText}</p>
                  </div>
                </div>
                <div style="padding: 0 1.5rem 1.5rem; display: flex; gap: 0.5rem; align-items: center;">
                  <button class="sed-btn sed-btn-primary btn-card-read" style="flex: 1; font-size: 0.88rem; font-weight: 700;">${ui.readBtn} ${art.yt ? '🎬' : '→'}</button>
                  <button class="sed-btn sed-btn-outline btn-card-share" data-share-url="https://www.jalud.eu/news/${slug}" style="padding: 0.55rem 0.75rem; font-size: 0.85rem; color: var(--navy-dark); border-color: var(--slate-line);" title="Kopírovat odkaz">🔗</button>
                </div>
              </div>
            `;
          }).join('')}
        </div>
      </div>
    </section>

    <!-- Section 2: Napsali o nás (External Media with initial 6 items + Expand/Collapse) -->
    <section class="sed-section" id="napsali-o-nas" style="background-color: var(--blue-ultra-light); border-top: 1px solid var(--slate-line); padding: 4rem 0 5rem;">
      <div class="sed-container">
        <div class="sed-section-header" style="text-align: left; margin-bottom: 2.5rem;">
          <div class="sed-eyebrow">${ui.externalEyebrow}</div>
          <h2 class="sed-section-title" style="font-size: 2.2rem;">${ui.externalTitle}</h2>
          <p class="sed-section-desc" style="margin: 0; max-width: 800px;">${ui.externalDesc}</p>
        </div>

        <div id="sed-external-media-grid" class="sed-grid-3" style="gap: 1.75rem;">
          <!-- Injected via JavaScript (Initial 6, Expandable) -->
        </div>

        <div style="text-align: center; margin-top: 2.5rem;" id="media-show-more-container">
          <button id="btn-toggle-media" class="sed-btn sed-btn-outline" style="font-weight: 800; font-size: 0.95rem; padding: 0.85rem 2rem; background: #ffffff; border: 2px solid var(--blue-primary); color: var(--blue-primary); border-radius: 12px; cursor: pointer; transition: all 0.2s;">
            ${ui.showMore}
          </button>
        </div>
      </div>
    </section>
  `;

  // Attach card click handlers for internal news
  container.querySelectorAll('[data-article-id]').forEach(card => {
    card.addEventListener('click', (e) => {
      if (e.target.closest('.btn-card-share')) return;
      const artId = card.getAttribute('data-article-id');
      openArticleModal(artId);
    });
  });

  // Attach share link copy handlers
  container.querySelectorAll('.btn-card-share').forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.stopPropagation();
      const url = btn.getAttribute('data-share-url');
      navigator.clipboard.writeText(url).then(() => {
        const orig = btn.innerText;
        btn.innerText = '✓';
        btn.style.borderColor = '#10b981';
        btn.style.color = '#10b981';
        setTimeout(() => {
          btn.innerText = orig;
          btn.style.borderColor = '';
          btn.style.color = '';
        }, 2000);
      }).catch(() => {
        prompt('Odkaz na článek:', url);
      });
    });
  });

  // Render external media mentions (initial 6, expandable)
  let isMediaExpanded = false;
  const mediaGrid = container.querySelector('#sed-external-media-grid');
  const toggleBtn = container.querySelector('#btn-toggle-media');

  function renderMediaCards() {
    if (!mediaGrid) return;
    const itemsToShow = isMediaExpanded ? allMediaArticles : allMediaArticles.slice(0, 6);

    mediaGrid.innerHTML = itemsToShow.map(art => `
      <div class="sed-card" style="display: flex; flex-direction: column; justify-content: space-between; background: #ffffff; border: 1.5px solid var(--slate-line); border-radius: 14px; padding: 1.5rem; box-shadow: 0 4px 15px rgba(0,0,0,0.03); transition: transform 0.2s, box-shadow 0.2s;" onmouseover="this.style.transform='translateY(-3px)'; this.style.boxShadow='0 10px 25px rgba(0,0,0,0.08)';" onmouseout="this.style.transform='none'; this.style.boxShadow='0 4px 15px rgba(0,0,0,0.03)';">
        <div>
          <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 0.85rem; flex-wrap: wrap; gap: 0.4rem;">
            <a href="${art.url}" target="_blank" rel="noopener noreferrer" style="font-size: 0.78rem; font-weight: 800; color: var(--navy-dark); background: #f1f5f9; padding: 3px 8px; border-radius: 6px; text-decoration: none; display: inline-flex; align-items: center; gap: 4px;" onmouseover="this.style.background='#e2e8f0'" onmouseout="this.style.background='#f1f5f9'">
              <span>${art.publisher}</span>
              <span style="font-size: 0.7rem;">↗</span>
            </a>
            <span style="font-size: 0.75rem; font-weight: 700; color: var(--blue-primary);">
              ${art.tag}
            </span>
          </div>

          <h4 style="font-size: 1.05rem; font-weight: 800; color: var(--navy-dark); line-height: 1.4; margin-bottom: 0.6rem;">
            <a href="${art.url}" target="_blank" rel="noopener noreferrer" style="color: var(--navy-dark); text-decoration: none; transition: color 0.2s;" onmouseover="this.style.color='var(--blue-primary)'; this.style.textDecoration='underline';" onmouseout="this.style.color='var(--navy-dark)'; this.style.textDecoration='none';">
              ${(lang === 'cs' && art.title_cs) ? art.title_cs : art.title}
            </a>
          </h4>

          <p style="font-size: 0.88rem; color: var(--text-dark); line-height: 1.55; margin-bottom: 1.25rem; display: -webkit-box; -webkit-line-clamp: 3; -webkit-box-orient: vertical; overflow: hidden;">
            ${(lang === 'cs' && art.desc_cs) ? art.desc_cs : art.desc}
          </p>
        </div>

        <div style="border-top: 1px solid var(--slate-line); padding-top: 1rem; display: flex; justify-content: space-between; align-items: center; gap: 0.75rem;">
          <span style="font-size: 0.75rem; color: var(--text-muted); font-weight: 700; background: #f8fafc; padding: 2px 6px; border-radius: 4px; border: 1px solid var(--slate-line);">
            ${art.year}
          </span>
          <a href="${art.url}" target="_blank" rel="noopener noreferrer" class="sed-btn sed-btn-outline" style="font-size: 0.82rem; font-weight: 700; padding: 6px 14px; text-decoration: none; display: inline-flex; align-items: center; gap: 4px; white-space: nowrap;">
            ${ui.readReport}
          </a>
        </div>
      </div>
    `).join('');

    if (toggleBtn) {
      if (allMediaArticles.length <= 6) {
        toggleBtn.style.display = 'none';
      } else {
        toggleBtn.style.display = 'inline-block';
        toggleBtn.innerText = isMediaExpanded ? ui.showLess : ui.showMore;
      }
    }
  }

  if (toggleBtn) {
    toggleBtn.addEventListener('click', () => {
      isMediaExpanded = !isMediaExpanded;
      renderMediaCards();
      if (!isMediaExpanded) {
        const sec = container.querySelector('#napsali-o-nas');
        if (sec) sec.scrollIntoView({ behavior: 'smooth' });
      }
    });
  }

  renderMediaCards();

  container.querySelectorAll('[data-route]').forEach(link => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      if (onNavigate) onNavigate(link.getAttribute('data-route'));
    });
  });

  return container;
}

// Backwards compatibility alias
export function renderNewsPage(onNavigate) {
  return renderNewsHubPage(onNavigate);
}
